import React from "react";
import FaIcon from "../Elements/FaIcon";
import FieldTypesEnum from "../Enums/FieldTypesEnum";
import JsxHelper from "../Helpers/JsxHelper";

export default class SftpDatumItem {
  constructor(item) {
    if (item === undefined) {
      this.SftpDataId = "";
      this.Host = "";
      this.Port = "";
      this.UserName = "";
      this.ServerName = "";
      this.IsActive = "true";
      this.DeleteDownloadedFiles = "true";
      this.PathOnTheServer = ".";
      this.Password = "";
    } else {
      this.initialize(item);
    }
  }

  async initialize(item) {
    this.SftpDataId = item.sftpDataId;
    this.Host = item.host;
    this.Port = item.port;
    this.UserName = item.userName;
    this.ServerName = item.serverName;
    this.IsActive = item.isActive;
    this.DeleteDownloadedFiles = item.deleteDownloadedFiles;
    this.PathOnTheServer = item.pathOnTheServer;
    this.Password = "";
  }

  static NameOfTheIdField() {
    return "SftpDataId";
  }
  static nameOfTheItemDetailList() {
    return "SftpDatum";
  }

  static MoneyFields = [];

  static Currency() {
    return "";
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return "";
  }

  static DateFields = [];

  static BoolFields = ["IsActive", "DeleteDownloadedFiles"];

  static FieldsToShowInListTable = [];

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  static FieldsToShowInDataTable() {
    return [
      { label: "SftpDataId", orderById: "SftpDataId", data: "SftpDataId", type: FieldTypesEnum.PureDataField /*FieldTypesEnum.DataFieldWithDetails*/, minWidth: 50 },
      { label: "Server Name", orderById: "ServerName", data: "ServerName", className: "text-center" },
      { label: "Host", orderById: "Host", data: "Host", minWidth: 50 },
      { label: "Port", orderById: "Port", data: "Port", className: "text-center", minWidth: 50 },
      { label: "Path On The Server", orderById: "PathOnTheServer", data: "PathOnTheServer", className: "text-center", minWidth: 50 },
      { label: "User Name", orderById: "UserName", data: "UserName", className: "text-center", minWidth: 50 },
      { label: "Is Active", orderById: "IsActive", data: (item) => JsxHelper.YesNo(item.IsActive), className: "text-center" },
      { label: "Delete Downloaded Files", orderById: "DeleteDownloadedFiles", data: (item) => JsxHelper.YesNo(item.DeleteDownloadedFiles), className: "text-center" },
      { label: "Actions", orderById: "", data: SftpDatumItem.getActionsContent, className: "text-center" },
    ];
  }

  static getActionsContent(item) {
    return (
      <div>
        <FaIcon iconName="fa-solid fa-edit" className="pointer link" tooltipText="Edit" onClick={() => SftpDatumItem.editFunction(item.SftpDataId, item)} />
      </div>
    );
  }

  static editFunction(id, item) {
    //this is just a placeholder
  }
}
